export default __webpack_public_path__ + "e2b4fc959375b405ed8d59bf769c6a2e.svg";